import Vue from 'vue';
const { $gettext } = Vue.prototype;
export default {
defaultEntity: {
  language: null,
  content: "",
  course: "",
  type: null,
  hashtags: [],
  photos: [],
  removePhotos: [],
  removeYoutubes: [],
  modifyTitles: [],
  youtubes: [],
},
layout(entity) {
  const { getters, state } = Vue.prototype.store;
  const { rules } = state.toggle;
  const userLanguages = state.location.languages;
  const siteLanguagesGettext = Object.keys(Vue.$translations)
  siteLanguagesGettext.forEach((siteLan, index) => {
    siteLanguagesGettext[index] = siteLan.split('_')[0]
  })
  const siteLanguages = state.location
                        .countryLang.filter(
                          language => siteLanguagesGettext.indexOf(language.code) !== -1
                        );
  let postLanguages = (userLanguages && userLanguages.length !== 0 ) 
                      ? userLanguages : siteLanguages
  if(entity.type == 8 && !window.cordova) {
    postLanguages = siteLanguages
  }
  const { postTypes } = state.post;
  return [
    {
      fieldName: 'language',
      type: 'langRadio',
      rules: [rules.required],
      items: postLanguages,
      itemValue: 'id',
      itemText: 'name',
      placeholder: $gettext('Choose language'),
      show: entity.type != 5
    },
    {
      fieldName: 'title',
      type: 'title',
      placeholder: $gettext('Title'),
      rules: [rules.required],
      show: entity.type == 8
    },
    {
      fieldName: 'content',
      type: entity.type == 8 ? 'editorInput' : 'textAreaTag',
      placeholder: $gettext('Description'),
      label: $gettext('Description'),
      rows: 4,
      rules: [rules.required],
      show: entity.type != 5
    },
    {
      fieldName: 'hashtags',
      type: 'hashtags',
      label: $gettext('Hashtags'),
      placeholder: $gettext('Enter value'),
      show: entity.type == 8
    },
    {
      fieldName: 'type',
      type: 'radio',
      items: postTypes,
      itemValue: 'id',
      itemText: 'name',
      class: 'radio-col-4 mb-2',
      show: (entity.type != 7 && entity.type != 5 && entity.type != 8) && !entity.isGolfCourse
    },
    {
      fieldName: 'course',
      type: 'multiSelect',
      placeholder: $gettext('Select a Golf Course'),
      rules: [rules.required],
      show: entity.type == 2 && !entity.isGolfCourse,
      action: 'searchCourse',
      multiple: false
    },
    {
      blockName: $gettext('Add to your post'),
      show: entity.type != 5 && entity.type != 8
    },
    {
      fieldName: 'photos',
      type: 'fileInput',
      show: entity.type != 8
    },
    {
      fieldName: 'youtubes',
      type: 'youtubeInput',
      rules: entity.type == 2 ? [rules.required] : [],
      show: entity.type != 8
    },
  ];
}
};
